export class Layout {
  constructor(difference) {
    this.createBlockTimes = 0
    this.width = 500
    this.height = 300
    this.top = 10
    this.left = 10
    this.moduleId = ""
    this.appId = ""
    this.isCache = true
    this.isShowTabs = true
    this.isShowTitle = true
    this.isShowMoreBtn = true
    this.activeIndex = 0
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderStyle = "solid" // solid dashed dotted
    this.borderColor = "#000000"
    this.borderWidth = 1
    this.boxShadowColor = "rgba(255,255,255,1)"
    this.boxShadowH = 0
    this.boxShadowV = 0
    this.boxShadowBlur = 0
    this.boxShadowSpread = 0
    this.clipSize = "cover"
    this.repeatType = "no-repeat"
    this.alignType = "center center"
    this.imgSrc = ""
    this.opacity = 100
    this.iconLocation = "left"
    this.background = []
    this.borderIsThemeColor = false
    this.topNavPaddingTypeFlag = 2
    this.padding = 0
    this.paddingTop = 0
    this.paddingRight = 0
    this.paddingLeft = 0
    this.paddingBottom = 0
    this.inBodyL = true
    this.inBodyR = true
    this.isDrawerModeL = false
    this.isDrawerModeR = false
    this.titleOptions = [
      {
        type: "top",
        elementOptions: [
          {
            innerElement: "cxTabs",
            isActive: false,
            isShow: true,
            type: "classification",
            options: {
              width: 100,
              height: 50,
              left: 0,
              top: 0,
              fontFamily: "sans-serif",
              fontSize: 24,
              hoverFontSize: 24,
              fontWeight: 400,
              hoverFontWeight: 400,
              color: "rgba(0,0,0,1)",
              hoverColor: "rgba(0,0,0,1)",
              lineHeight: 22,
              hoverLineHeight: 22,
              letterSpacing: 0,
              hoverLetterSpacing: 0,
              fontStyle: "normal",
              hoverFontStyle: "normal",
              textAlign: "left",
              hoverTextAlign: "left",
              writingMode: "horizontal-tb",
              hoverWritingMode: "horizontal-tb",
              textDecoration: "none",
              hoverTextDecoration: "none",
              textIndent: 0,
              hoverTextIndex: 0,
              maxLength: 2,
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              borderColor: "rgba(255,255,255,1)",
              hoverBorderColor: "rgba(255,255,255,1)",
              tabWidth: 50,
              tabHeight: 40,
              bgColor: "rgba(255,255,255,1)",
              hoverBgColor: "rgba(255,255,255,1)",
              marginRight: 40,
              activeIndex: 0,
              tabsList: ["Tab1", "Tab2"],
              isShowBackgroundModel: "有背景",
              animateSets: {
                animateType: 0,
                animateDirection: "无",
                animateDuration: 1.5,
                animateDelay: 0,
                hasDirection: false,
                animateTriggerNumType: "单次触发",
                animateClass: "",
                executionAnimateClass: ""
              }
            }
          }
        ]
      },
      {
        type: "bottom",
        elementOptions: []
      },
      {
        type: "left",
        elementOptions: []
      },
      {
        type: "right",
        elementOptions: []
      }
    ]
    this.rows = [
      {
        height: "100%",
        alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
        cols: [
          //width加起来不能大于12
          {
            uid: "cxzfdf24321",
            alignSelf: "stretch", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
            md: 3, //单个宽度 不用cols，统一用md
            appMd: 12,
            offsetMd: 0, //偏移量
            height: "100%",
            // innerElement: null,
            rows: [
              {
                height: "40%",
                margin: {
                  //!!!!!!!!!!!!!!!!!注意！！！加margin top/left会影响对齐准确度
                  Top: "0%" //可配置margin
                },
                alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
                cols: [
                  //width加起来不能大于12
                  {
                    uid: "23425345trygfbcrerw",
                    alignSelf: "center", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
                    height: "100%",
                    md: 12, //单个宽度 不用cols，统一用md
                    offsetMd: 0, //偏移量
                    //如果要在cols中增加rows，以👇形式增加
                    elementOptions: [],
                    componentBoxOptions: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      paddingRight: 0,
                      borderStyle: "solid", // solid, dashed, dotted
                      borderColor: "rgba(255,255,255,1)",
                      borderWidth: 5,
                      clipSize: "cover",
                      repeatType: "no-repeat",
                      alignType: "center center",
                      imgSrc: "",
                      opacity: 100
                    }
                  }
                ]
              },
              {
                height: "40%",
                margin: {
                  Top: "0%" //可配置margin
                },
                alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
                cols: [
                  //width加起来不能大于12
                  {
                    uid: "n42o34n23o4n2",
                    rows: null,
                    alignSelf: "stretch", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
                    height: "100%",
                    md: 12, //单个宽度 不用cols，统一用md
                    offsetMd: 0, //偏移量
                    // innerElement: null,
                    elementOptions: [],
                    componentBoxOptions: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      paddingRight: 0,
                      borderStyle: "solid", // solid, dashed, dotted
                      borderColor: "rgba(255,255,255,1)",
                      borderWidth: 5,
                      clipSize: "cover",
                      repeatType: "no-repeat",
                      alignType: "center center",
                      imgSrc: "",
                      opacity: 100
                    }
                  }
                ]
              }
            ]
          },
          {
            uid: "123deqrwefx",
            alignSelf: "stretch",
            md: 4,
            appMd: 12,
            height: "100%",
            offsetMd: 1,
            rows: [
              {
                height: "100%",
                margin: {
                  Top: "0%" //可配置margin
                },
                alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
                cols: [
                  {
                    uid: "zvdsw323wes",
                    alignSelf: "center", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
                    height: "100%",
                    md: 12, //单个宽度 不用cols，统一用md
                    offsetMd: 0, //偏移量
                    elementOptions: [],
                    componentBoxOptions: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      paddingRight: 0,
                      borderStyle: "solid", // solid, dashed, dotted
                      borderColor: "rgba(255,255,255,1)",
                      borderWidth: 5,
                      clipSize: "cover",
                      repeatType: "no-repeat",
                      alignType: "center center",
                      imgSrc: "",
                      opacity: 100
                    }
                  }
                ]
              }
            ]
          },
          {
            uid: "12312dsda",
            alignSelf: "stretch",
            md: 4,
            appMd: 12,
            height: "100%",
            offsetMd: 0,
            component: null,
            rows: [
              {
                height: "100%",
                margin: {
                  Top: "0%" //可配置margin,首字母大写
                },
                alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
                cols: [
                  {
                    uid: "czx09c7zx0c9z0c9",
                    alignSelf: "center", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
                    height: "100%",
                    md: 12, //单个宽度 不用cols，统一用md
                    offsetMd: 0, //偏移量
                    elementOptions: [],
                    componentBoxOptions: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      paddingRight: 0,
                      borderStyle: "solid", // solid, dashed, dotted
                      borderColor: "rgba(255,255,255,1)",
                      borderWidth: 5,
                      clipSize: "cover",
                      repeatType: "no-repeat",
                      alignType: "center center",
                      imgSrc: "",
                      opacity: 100
                    }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        height: "100%",
        alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
        cols: [
          //width加起来不能大于12
          {
            uid: "cxzf1df24321",
            alignSelf: "stretch", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
            md: 3, //单个宽度 不用cols，统一用md
            appMd: 12,
            offsetMd: 0, //偏移量
            height: "100%",
            // innerElement: null,
            rows: [
              {
                height: "40%",
                margin: {
                  //!!!!!!!!!!!!!!!!!注意！！！加margin top/left会影响对齐准确度
                  Top: "0%" //可配置margin
                },
                alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
                cols: [
                  //width加起来不能大于12
                  {
                    uid: "234253451trygfbcrerw",
                    alignSelf: "center", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
                    height: "100%",
                    md: 12, //单个宽度 不用cols，统一用md
                    offsetMd: 0, //偏移量
                    //如果要在cols中增加rows，以👇形式增加
                    elementOptions: [],
                    componentBoxOptions: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      paddingRight: 0,
                      borderStyle: "solid", // solid, dashed, dotted
                      borderColor: "rgba(255,255,255,1)",
                      borderWidth: 5,
                      clipSize: "cover",
                      repeatType: "no-repeat",
                      alignType: "center center",
                      imgSrc: "",
                      opacity: 100
                    }
                  }
                ]
              },
              {
                height: "40%",
                margin: {
                  Top: "0%" //可配置margin
                },
                alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
                cols: [
                  //width加起来不能大于12
                  {
                    uid: "n42o34n231o4n2",
                    rows: null,
                    alignSelf: "stretch", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
                    height: "100%",
                    md: 12, //单个宽度 不用cols，统一用md
                    offsetMd: 0, //偏移量
                    // innerElement: null,
                    elementOptions: [],
                    componentBoxOptions: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      paddingRight: 0,
                      borderStyle: "solid", // solid, dashed, dotted
                      borderColor: "rgba(255,255,255,1)",
                      borderWidth: 5,
                      clipSize: "cover",
                      repeatType: "no-repeat",
                      alignType: "center center",
                      imgSrc: "",
                      opacity: 100
                    }
                  }
                ]
              }
            ]
          },
          {
            uid: "123d2eqrwefx",
            alignSelf: "stretch",
            md: 4,
            appMd: 12,
            height: "100%",
            offsetMd: 1,
            rows: [
              {
                height: "100%",
                margin: {
                  Top: "0%" //可配置margin
                },
                alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
                cols: [
                  {
                    uid: "zvdsw1323wes",
                    alignSelf: "center", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
                    height: "100%",
                    md: 12, //单个宽度 不用cols，统一用md
                    offsetMd: 0, //偏移量
                    elementOptions: [],
                    componentBoxOptions: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      paddingRight: 0,
                      borderStyle: "solid", // solid, dashed, dotted
                      borderColor: "rgba(255,255,255,1)",
                      borderWidth: 5,
                      clipSize: "cover",
                      repeatType: "no-repeat",
                      alignType: "center center",
                      imgSrc: "",
                      opacity: 100
                    }
                  }
                ]
              }
            ]
          },
          {
            uid: "12312ds2da",
            alignSelf: "stretch",
            md: 4,
            appMd: 12,
            height: "100%",
            offsetMd: 0,
            component: null,
            rows: [
              {
                height: "100%",
                margin: {
                  Top: "0%" //可配置margin,首字母大写
                },
                alginH: "center", //水平对齐，start左对齐，center居中对齐，around分散对齐，between两端对齐
                cols: [
                  {
                    uid: "czx019c7zx0c9z0c9",
                    alignSelf: "center", //单个col的垂直对齐，start顶部对齐，center水平对齐，end底部对齐，stretch高度拉满
                    height: "100%",
                    md: 12, //单个宽度 不用cols，统一用md
                    offsetMd: 0, //偏移量
                    elementOptions: [],
                    componentBoxOptions: {
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      paddingRight: 0,
                      borderStyle: "solid", // solid, dashed, dotted
                      borderColor: "rgba(255,255,255,1)",
                      borderWidth: 5,
                      clipSize: "cover",
                      repeatType: "no-repeat",
                      alignType: "center center",
                      imgSrc: "",
                      opacity: 100
                    }
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
    this.updateTimer = 100 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.usePageQuery = false //页面传参
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
